import { Link } from "react-router-dom";

export const Logo = ({ to = "/", size = 34, testId = "brand-logo" }) => (
  <Link to={to} data-testid={testId} className="group inline-flex items-center gap-2.5">
    <img src="/logo.png" alt="" width={size} height={size} className="rounded-md transition-transform duration-300 group-hover:-rotate-6" />
    <span className="font-serif text-[22px] font-semibold tracking-tight text-ink">Pitchpaper</span>
  </Link>
);
